<template>
<div>
  <v-card>
        <TradeRequestListsOfResponsesPerItem></TradeRequestListsOfResponsesPerItem>
      <!-- </v-card-text> -->
  </v-card>
</div>
</template>
<script>
import TradeRequestListsOfResponsesPerItem from '../components/TradeRequestListsOfResponsesPerItem.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestListsOfResponsesPerItem
  },
  methods: {
    
  },
};
</script>

<style></style>